export enum CFAttrType {
	Validation = 'Validation',
	ReactTable = 'ReactTable',
}

export enum CFAttrKey {
	ForceRequired = 'ForceRequired',
	initFromStammKost = 'initFromStammKost',
	initFromStammKostAttr = 'initFromStammKostAttr',
	initValue = 'initValue',
	initValueFromTask = 'initValueFromTask',
	initValueFromTaskAttr = 'initValueFromTaskAttr',
	filterable = 'filterable',
	filterMethod = 'filterMethod',
	preserveDateRangeForAttribute = 'preserveDateRangeForAttribute',
	preserveDateRangeForCFDef = 'preserveDateRangeForCFDef',
	remoteSetterDq = 'remoteSetterDq',
	remoteSetterDqParam = 'remoteSetterDqParam',
	remoteSetterDstAttr = 'remoteSetterDstAttr',
	remoteSetterDstCFDefId = 'remoteSetterDstCFDefId'
}